
const FetchResiliencDropdownFilterReducer = (state = { type: 'LOADING_RESILIENC_DROPDOWN_FILTERS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RESILIENC_DROPDOWN_FILTERS_ACTION':
            return action
        case 'RESET_RESILINC_DROPDOWN_FILTER_TYPE':
            return {
                ...state,
                type: action.payload
            };    
        default:
            return state
    }
}
const FetchResiliencFilterReducer = (state = { type: 'LOADING_RESILIENC_FILTER_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RESILIENC_FILTER_ACTION':
            return action
        default:
            return state
    }
}

const FetchResilincMainReducer = (state = { type: 'LOADING_RESILINC_MAIN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RESILINC_MAIN_ACTION':
            return action
        default:
            return state
    }
}
const FetchResilincDetailReducer = (state = { type: 'LOADING_RESILINC_DETAIL_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RESILINC_DETAIL_ACTION':
            return action
        case 'RESET_RESILINC_DETAIL_TYPE':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const FetchResilincFilterReducer = (state = { type: 'LOADING_RESILINC_FILTER_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_RESILINC_FILTER_ACTION':
            return action
        case 'RESET_RESILINC_FILTER_TYPE':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

export {
    FetchResiliencDropdownFilterReducer,
    FetchResiliencFilterReducer,
    FetchResilincMainReducer,
    FetchResilincDetailReducer,
    FetchResilincFilterReducer
}